import React from 'react';
import { withContent } from '../../../hoc/withContext';
import './CategoriesDealsBlock.scss';
import { IContent } from '../../../types';

import CategoryDealElement from '../../Elements/CategoryDeal/CategoryDealElement';
import Title from '../../Elements/Title/TitleElement';

interface ICategoriesDealsProps {
  context?: IContent
}

const CategoriesDealsBlock = ({ context }: ICategoriesDealsProps) => {
  const { categories_deals } = context;
  const { items, is_active, title } = categories_deals;
  return is_active && (
    <div className="block-container-categories_deals">
      <Title>{title}</Title>
      <div className="block-categories_deals">
        {items.length > 0 && items.map((category, index) => (
          <CategoryDealElement
            key={index}
            category={category}
            index={index}
          />
        ))}
      </div>
    </div>
  );
};

export default withContent(CategoriesDealsBlock);
